export const WEEKLY_MENU = {
  headingLine1: 'New recipes',
  headingLine2: 'every Tuesday',
  cookedByYouLabel: 'Cooked by you',
  cookedByUsLabel: 'Cooked by us',
  trendingLabel: "What's trending",
  cookedByUsTag: 'New',
  cookedByUsDescriptionPrefix: 'NEW | ',
  // The embedded \n's only apply where `white-space: pre-line` is set (mobile) — natural wrap
  // alone would break after "one" instead of "meals," and strand "your" alone on a line, so the
  // break points are hardcoded to match Figma. Elsewhere they collapse to a space and natural
  // wrap takes over.
  cookedByUsDescription:
    'Chef-designed ready meals,\neach one a source of protein and 2 of\nyour 5-a-day.',
  cookedByUsRibbonLeft: 'Cooked by us',
  cookedByUsRibbonRight: 'No nasties',
}

export const CTA_HREF = '/menu?collection=all-recipes'
export const CTA_LABEL = 'Open this week’s menu'

export const TRENDING_PILLS = [
  'Quick & Easy',
  'Healthy',
  '30g+ protein',
  'Vegetarian',
  'Vegan',
  'Gluten-free',
  'Dairy-free',
]

export type ActiveTab = 'cookedByYou' | 'cookedByUs'
